(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mmol-renewal-contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const form = document.getElementById('contact_form');
    if (!form || form.dataset.mmolContactReady) return;
    form.dataset.mmolContactReady = 'true';
    const interestInput = form.querySelector('[data-mmol-contact-interest-input]');
    const interestNote = form.querySelector('[data-mmol-contact-interest-note]');
    const category = form.querySelector('#mmol-contact-category');
    const allowedInterests = ['Metis', 'Metis 費用相談', 'MMOL Sync', 'Sync', 'AI・業務改善', '人事・採用', 'Web・EC'];
    const queryInterest = new URLSearchParams(window.location.search).get('interest');
    if (interestInput) {
      const interest = interestInput.value || (allowedInterests.includes(queryInterest) ? queryInterest : '');
      if (allowedInterests.includes(interest)) {
        interestInput.value = interest;
        interestNote.textContent = 'ご関心のある支援：' + interest;
        interestNote.hidden = false;
        if (category && !category.value) category.value = interest === 'Metis 費用相談' ? 'お見積もりの依頼' : 'サービスについて';
      }
    }
    const feedback = form.querySelector('[data-mmol-contact-feedback]');
    if (feedback) feedback.focus();
    const button = form.querySelector('[data-mmol-contact-submit]');
    const progress = form.querySelector('[data-mmol-contact-progress]');
    let resetTimer;
    const reset = () => {
      delete form.dataset.mmolSubmitting;
      form.removeAttribute('aria-busy');
      if (button) button.disabled = false;
      if (progress) progress.textContent = '';
      clearTimeout(resetTimer);
    };
    window.addEventListener('pageshow', reset);
    form.addEventListener('submit', (event) => {
      if (form.dataset.mmolSubmitting) {
        event.preventDefault();
        return;
      }
      queueMicrotask(() => {
        if (event.defaultPrevented) return;
        form.dataset.mmolSubmitting = 'true';
        form.setAttribute('aria-busy', 'true');
        if (button) button.disabled = true;
        if (progress) progress.textContent = '送信しています。';
        resetTimer = window.setTimeout(reset, 20000);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
